import * as React from "react";
import { singleton } from "logic/singleton";
const defaultWidgetRendering = {
  limitHeight: true
};
const WidgetRenderingContext = React.createContext(defaultWidgetRendering);
export default singleton("contexts.WidgetRenderingContext", () => WidgetRenderingContext);
